module.exports = __webpack_public_path__ + "img/instagram-color.f3d2cca2.svg";